/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import Helmet from 'react-helmet';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';
import { Container, Row, Col } from 'reactstrap';

import './style.scss';
import favicon from './img/logo.png';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'Radiusnet';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => parameters.client_id && parameters.redirect_uri && parameters.response_type

  return (
    <Container fluid={true} className="radiusnet-body">
      <Helmet>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>
      <Row>
        {
          _validateParams()
            ? <LoginForm
              api={api}
              location={location}
            />
            : <RequestLoginErrorMessage
              onlyMessage={true}
              message={translate('RequestLoginErrorMessage')}
            />
        }
        <Col sm="4"></Col>
      </Row>
    </Container>
  )
}

export default Login;
